<template>
  <gru-table :resource_title="'lang.user.title'" :resource="'user'" :fields="fields" :enabledExcel="false" :enabledPrint="false" primary-key="userId" :pagination="pagination">
  </gru-table>
</template>

<script>
import { userContants } from "@/constants";
import { mapState } from "vuex";

export default {
  name: 'UserList',
  data: () => {
    return {
      pagination:{
        descending: true,
        page: 1,
        rowsPerPage: 10,
        sortBy: "user_name",
        totalItems: 0,
        rowsPerPageItems: [10, 20],
        paging: true
      }
    }
  },
  computed: {
    ...mapState({
      roleList: state => state.role.roleList
    }),
    fields() {
      return [
        {text: 'lang.user.username', value: 'userName',  editable: true},
        {text: 'lang.user.email', value: 'email', nodeCode: 'customer'
        },
        {text: 'lang.user.fullName', value: 'fullName' },
        {text: 'lang.user.phone', value: 'phone'},

        {text: 'lang.user.role', value: 'role', width: "150px", render: (value)=>{
            for(let i =0;i< this.roleList.length;i++){
              let item = this.roleList[i];
              if(item.id == value){
                  return item.roleName;
              }
            }
            return "";
          },
          optionValues: this.roleList, columnType: 'SELECT', itemText: "roleName", itemValue: "id", filterColumn: "role"
        },
        {text: 'lang.user.status', value: 'status', width: "150px", optionValues: userContants.allStateTypes,columnType: 'SELECT' },
      ]
    }
  },
  created() {
    this.$store.dispatch("role/getRoleList");
  },
}
</script>
